import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import * as items from '../Items';
import Collapse from '../../Global/Collapse/Collapse';
import Icon from '../../Global/Icons/Icon';
import ItemColorSelect from '../ItemColorSelect';

const DiagramCreatorEquipment = ({ activeColor, changeColor }) => (
  <Collapse
    show
    trigger={
      <div>
        Equipment <span className="text-grey">(drag)</span>
        <Icon name="arrow-down" size="m" fill="black" />
      </div>
    }
    content={
      <div className="sidebar-dropdown">
        <ItemColorSelect activeColor={activeColor} changeColor={changeColor} />

        <ul className="col-3">
          <li>
            <div className="tool-drag ball">
              <div id="ball" className="tool-drag-svg">
                {renderHTML(items.BALL.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div style={{ fill: activeColor }} className="tool-drag cone-small">
              <div id="cone_small" className="tool-drag-svg">
                {renderHTML(items.CONE_SMALL.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div style={{ fill: activeColor }} className="tool-drag cone-large">
              <div id="cone_large" className="tool-drag-svg">
                {renderHTML(items.CONE_LARGE.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div className="tool-drag goal-large">
              <div id="goal_large" className="tool-drag-svg">
                {renderHTML(items.GOAL_LARGE.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div className="tool-drag goal-small">
              <div id="goal_small" className="tool-drag-svg">
                {renderHTML(items.GOAL_SMALL.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div className="tool-drag mannequin">
              <div id="mannequin" className="tool-drag-svg">
                {renderHTML(items.MANNEQUIN.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div className="tool-drag ladder">
              <div id="ladder" className="tool-drag-svg">
                {renderHTML(items.LADDER.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div className="tool-drag hurdle">
              <div id="hurdle" className="tool-drag-svg">
                {renderHTML(items.HURDLE.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>

          <li>
            <div className="tool-drag slalom-pole">
              <div id="slalom_pole" className="tool-drag-svg">
                {renderHTML(items.SLALOM_POLE.svg)}
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    }
  />
);

DiagramCreatorEquipment.propTypes = {
  activeColor: PropTypes.string,
  changeColor: PropTypes.func,
};

export default DiagramCreatorEquipment;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Tools/DiagramCreatorEquipment.js